<template>
  <section
    v-if="props.data"
    class="bannerTitleDescrButton"
    :class="[props.data.parentClasses, props.data.parentStyle ? props.data.parentStyle : 'defaultStyle', { 'cta-section parallax-container': props.data.paralaxBg && props.data.paralaxBg !== 'false' }]"
  >
    <!-- <div
      v-if="!props.data.paralaxBg"
      class="bg"
      :style="`background: url(${img('/img/widgets/decor-dot-blue.png', { modifiers: { format: 'webp' } })});`"
    ></div> -->

    <div class="container">
      <div class="row justify-content-center">
        <div
          class="col"
          :class="props.data.parentStyle === 'secondStyle' ? 's12 m10 l8' : 's10 m9 l9'"
        >
          <div
            class="section-heading center-align"
            :class="[ props.data.parentClasses && props.data.parentClasses.includes('lg') ? 'lg' : '' ]"
          >
            <h2
              v-if="props.data.title"
              class="title mb-4 title-style h2"
              :class="[ props.data.parentStyle === 'secondStyle' ? 'flow-text' : '' ]"
              v-html="convertToHtml(props.data.title)"
            ></h2>

            <div
              v-if="props.data.descr"
              class="descr"
              v-html="convertToHtml(props.data.descr)"
            ></div>

            <div
              v-if="props.data.subTitle"
              class="subTitle h4"
              v-html="convertToHtml(props.data.subTitle)"
            ></div>
          </div>
        </div>
      </div>

      <div class="btn-holder center-align mb-4">
        <NuxtLink
          v-if="props.data.buttonTitle && props.data.link"
          role="button"
          :to="props.data.link"
          :title="props.data.buttonTitle"
          class="btn waves-effect waves-light"
          :class="props.data.buttonClasses ? props.data.buttonClasses : 'orange'"
        >
          {{ props.data.buttonTitle }}
        </NuxtLink>

        <button
          v-else-if="props.data.feedbackEnable && props.data.buttonTitle"
          role="button"
          :title="props.data.buttonTitle"
          class="btn waves-effect waves-light"
          :class="props.data.buttonClasses ? props.data.buttonClasses : 'orange'"
          @click="drawerOptions.conversation = {
            componentId: 'FormsGroupConversationsFeedback',
            header: props.data.buttonTitle,
            data: {
              form: props.data,
              redirectLink: '/page/thank-you-108'
            },
            buttons: false,
            returnData: () => { }
          }"
        >
          {{ props.data.buttonTitle }}
        </button>

        <a
          v-else-if="props.data.anchor && props.data.buttonTitle"
          href="#"
          role="button"
          :title="props.data.buttonTitle"
          class="btn waves-effect waves-light"
          :class="props.data.buttonClasses ? props.data.buttonClasses : 'orange'"
          @click="props.data.anchor === '#liveChat'
            ? openLiveChat($event)
            : scrollTo($event, props.data.anchor)"
        >
          {{ props.data.buttonTitle }}
        </a>
      </div>

      <div
        class="center-align text-second-800 text-[22px] md:text-[24px] mb-2"
        :class="[ props.data.parentClasses && props.data.parentClasses.includes('lg') ? 'lg' : '' ]"
      >
        <div
          v-if="props.data.afterContent"
          class="descr afterContent"
          v-html="convertToHtml(props.data.afterContent)"
        ></div>
      </div>
    </div>

    <div
      v-if="props.data.paralaxBg && props.data?.paralaxBg !== 'false'"
      class="parallax"
    >
      <NuxtPicture
        preload
        :img-attrs="{class: 'responsive-img', alt: props.data.title}"
        :src="props.data.paralaxBg"
        :placeholder="[100, 60, 40]"
      />
    </div>
  </section>
</template>

<script setup>
const { drawerOptions } = usePopups()

/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})

const openLiveChat = ($e) => {
  $e.preventDefault()

  if (document.querySelector('#pb_sidebar')) {
    document.querySelector('#pb_sidebar').click()
  }
}
</script>

<style lang="scss" scoped>
.bannerTitleDescrButton {
  position: relative;
  display: flex;
  align-items: center;
  & > .container {
    position: relative;
    z-index: 1;
  }
  &.blue-white {
    color: color("primary-color", "base-2");
    .title,
    .descr,
    .subTitle {
      color: color("primary-color", "base-2");
    }
  }
  &.text-white {
    color: #fff;
    .title,
    .descr,
    .subTitle {
      color: #fff;
    }
  }
  .bg {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: .3;
  }
  &:before {
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    min-height: 100%;
    background: linear-gradient(to bottom, #f6f7f9 1%, rgba(234,237,240,.3) 100%);
    opacity: 1;
  }

  &.isUkraine .yellow {
    color: #0057b8 !important;
    background-color: #ffd700 !important;
  }
}

.parallax-container {
  &:before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background: $paralax-overflow-color;
  }
  &.no-overflow {
    &:before {
      display: none;
    }
  }

  .parallax {
    &:deep(img) {
      @media only screen and (min-width: 993px) {
        width: auto;
        max-width: fit-content;
        min-height: 100%;
        max-height: 125%;
      }
    }
  }

  /**
  * Default Style
  */
  &.secondStyle_2 {
    @media only screen and (min-width: 601px) {
      min-height: 57.8125vh;
      min-height: calc(var(--vh, 1vh) * 57.8125);
      max-height: 57.8125vh;
      max-height: calc(var(--vh, 1vh) * 57.8125);
      margin: 0;
      text-align: left;
    }
    @media only screen and (min-width: 993px) {
      min-height: 80vh;
      min-height: calc(var(--vh, 1vh) * 80);
      max-height: 80vh;
      max-height: calc(var(--vh, 1vh) * 80);
    }
  }
}
</style>
